import React, { createContext, useContext, useState, useCallback } from 'react';
import { ToastContainer } from '../components/ui/Toast';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((toast) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { ...toast, id }]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const showError = useCallback((message, duration = 8000) => {
    return addToast({ type: 'error', message, duration });
  }, [addToast]);

  const showSuccess = useCallback((message, duration = 5000) => {
    return addToast({ type: 'success', message, duration });
  }, [addToast]);

  const showWarning = useCallback((message, duration = 6000) => {
    return addToast({ type: 'warning', message, duration });
  }, [addToast]);

  const showInfo = useCallback((message, duration = 5000) => {
    return addToast({ type: 'info', message, duration });
  }, [addToast]);

  const value = {
    showError,
    showSuccess,
    showWarning,
    showInfo,
    addToast,
    removeToast,
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </ToastContext.Provider>
  );
};
